import React, {cloneElement, useContext, useEffect, useState} from 'react';
import {useHistory} from 'react-router-dom';
import {ApplicableTableSettings, infoAreaBicTable, TableColumn, TableSettings} from "../../../tableSettings";
import AbstractListView, { DataFetchResult, ExportRowRenderer, ListCustomFilterRenderer, ListOrderBy, ListRowRenderer } from "../../common/AbstractListView";
import lockRed from '../../../img/lock_red.png';
import constants from '../../../constants';
import {Search} from "../../../filtering";
import {NavigationType, openNewPage} from '../../../util/navigationHelpers';
import { CurrencyAmountRenderer, DateRenderer, DateTimeIncludeSecRenderer, DateTimeRenderer,
  FloatRenderer, NullableCheckboxIconRenderer, TextAlignLeftRenderer, TextAlignRightRenderer, TextRenderer
} from '../../../uiControls/SmartTableRenderers';
import UniqueLinkButton from '../../../uiControls/UniqueLinkButton';
import PrimaryButton from '../../../ui/PrimaryButton';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faCopy, faFileAlt, faPencilAlt, faPlus, faTrashAlt,} from '@fortawesome/free-solid-svg-icons';
import useGlobalYesNoDialog from '../../../hooks/useGlobalYesNoDialog';
import ApplicationContext from '../../../ApplicationContext';
import JobListViewContext, { RightClickContext } from '../../common/JobListViewContext';
import useGlobalOkDialog from '../../../hooks/useGlobalOkDialog';
import {ActionButtonItem, borderColors, splitMenuItemsIntoSections} from '../../../ui/ActionButton';
import useFunctionKeys from '../../../hooks/useFunctionKeys';
import InfoAreaDrawer from '../../../uiControls/infoArea/InfoAreaDrawer';
import CurrencyLabel from '../../../uiControls/CurrencyLabel';
import SmartTable from '../../../uiControls/SmartTable';
import {getJobNameFromInvBillCrDbJobType, JobNames} from "../../../framework.core/JobNames";
import {generalInvoiceList} from "../tableSettings";
import {InvoiceListItem} from "../../../fms.data/models/InvoiceListItem";
import IfmsModal from "../../../ui/IfmsModal";
import ListViewShortcutMenu from '../../common/ListViewShortcutMenu';
import ToolboxMenuItem from '../../../uiControls/ToolboxMenuItem';
import Menu, { IfmsMenuItem } from '../../../ui/menu/Menu';
import JobListSuntekCommand from '../../common/JobListSuntekCommand';
import { DraftFilterRenderer, StatusNotUseFileLockedRenderer, VoidFilterRenderer } from '../../common/commonListRenderers';
import { FmsSecTask } from '../../../fms.core/constants';
import {  getFmsGlobal } from '../../../globals';
import CustomerBalanceDetails from '../../reports/AccountBalance';
import { nowDate } from '../../../dateUtils';
import { SuntekSettings, SystemSettings } from '../../../ifmsTypes';
import { findSecurityTask } from '../../../util';
import * as XCol from "../../../framework.core/XExportColumn";
import CheckBoxUncontrolled from '../../../ui/CheckBoxUncontrolled';
import { FmsSecCntr } from '../../../fms.core/constants/FmsSecCntr';
import { FormType } from '../../../fms.enum';
import { CurrencyAmountValue, nullableCheckBoxValue, DateTimeSecond } from '../../common/commonExportFormat';
import BatchPrint from '../../reports/BatchPrint';
import { DocumentType } from '../../../framework.core/DocumentType';
import { getSelectedSubMenuArgs } from '../../JobListSubMenu';
import { FmsSubMenu } from '../../../constants/fmsSubMenu';
import useReportViewer from '../../../hooks/useReportViewer';

function IndicatorRenderer({ data, row}:any) {
  const l = data[row.index];
  let dataTooltip = '';
  const lStatus = (l as any).status as string;
  if (lStatus === 'PC') dataTooltip = 'Period Close';

  // function onIndicatorClick() {
  //   if (jobListContext.rowExtrasId) {
  //     return; // Some row is already selected
  //   }

  //   jobListContext.setRowExtrasId(data[row.index].id);
  // }

  let content: React.ReactNode = <></>;
  if (lStatus === 'PC')
    content = <img height="7px" src={lockRed} id={'redIcon'} style={{ position: 'relative', top: '0px' }} alt="" />;


  return (
    //div className="ifms-table-default" data-tooltip="B/L Status" style={{width: '100%', minHeight: '22px', cursor: 'pointer'}} onClick={onIndicatorClick}>{content}</div>
    <div className="ifms-table-default" id={`ifms-table-default-${row.index}`} data-tooltip={dataTooltip} style={{ width: '100%', minHeight: '22px' }}>{content}</div>
  );
}

function DraftRenderer({cell}:any) {
  if (cell && cell.value) {
    return (
      <div data-tooltip={'Draft'} className="ifms-table-default">
        <span style={{color: 'green'}}>V</span>
      </div>
    );
  }
  
  return <div className="ifms-table-default"></div>;
}

function VoidRenderer({cell}:any) {
  if (cell && cell.value === 1) {
    return (
      <div data-tooltip={'Void'} className="ifms-table-default">
        <span style={{color: 'red'}}>V</span>
      </div>
    );
  }
  
  return <div className="ifms-table-default"></div>;
}

function CurrencyRenderer(value: number | null | undefined, currency: string, isLast: boolean = false) {
  return (
    <div style={{height: '100%'}}>
      <div style={{paddingTop: '0px', lineHeight: '12px', paddingRight: !isLast ? '15px' : '25px', textAlign: 'right'}}>
        <CurrencyLabel currency={currency} value={value}/>
      </div>
    </div>
  );
}

function AccountingEntityRenderer(onLinkToAccounting: any, {data, row, value}: any) {
  const entity = data[row.index];

  return <div style={{marginTop: '0px', marginLeft: '5px', textAlign: 'left'}}>
    <button className="e-btn e-small e-link" style={{margin: '0', padding: '0', lineHeight: '12px', color: '#0d7757'}}
            onClick={() => onLinkToAccounting(entity)}>{value}</button>
    &nbsp;
  </div>;
}


function ConfirmedRenderer({ value, row }: any) {
  const appContext = useContext(ApplicationContext);
  const jobListContext = useContext(JobListViewContext);
  const [showGlobalOkDialog] = useGlobalOkDialog();


    let secCont = appContext.securityControls ? appContext.securityControls[JobNames.GInvo] : null;
    if (!secCont) {
      secCont = [{ secCntr: FmsSecCntr.GInvGiveCredit, contName: 'cmdNew10' },
      { secCntr: FmsSecCntr.GInvCancelCredit, contName: 'cmdNew12' },
      { secCntr: FmsSecCntr.GInvConfirmed, contName: 'chkConfirmed' },
      { secCntr: FmsSecCntr.GInvDraft, contName: 'chkDraft' }
    ];

      appContext.setSecurityControls(JobNames.GInvo, secCont);
    }
  

  async function updateConfirmed(newValue: boolean) {
    await appContext.api.setInvoiceConfirmed(row.original.id, newValue);
    row.original.confirmed = newValue;
    jobListContext.updateDataRow(row.original);
  }

  function findClickedCell(element: Element): Element | null {
    for (let i = 0; i < 6; ++i) {
      if (!element) {
        break;
      }
      if (Array.from(element.classList).some(className => className.startsWith('row-'))) {
        return element;
      }
      element = element.parentNode as Element;
    }
    return null;
  }

  return (
    <div style={{ width: '100%', textAlign: 'center' }}>
      <CheckBoxUncontrolled
        key={row.original.id}
        initialValue={Boolean(value)}
        onChange={updateConfirmed}
        disabled={appContext.getControlDisableStatus(JobNames.GInvo, 'chkConfirmed', FormType.ModeEdit)}
        allowOnChange={async (e) => {
          if (!e) return false;

          e?.stopPropagation();

          const element = findClickedCell(e.currentTarget);
          if (!element) {
            await showGlobalOkDialog(<p>Cannot find hover element</p>, false, null, 'warning');
            return false;
          }

          const classes = element.classList;
          const mouseOverRowIndex = Array.from(classes).find(className => className.includes('row-'))?.match(/\d+$/)?.[0];

          if (!mouseOverRowIndex || !jobListContext.data) {
            await showGlobalOkDialog(<p>Cannot find hover data</p>, false, null, 'warning');
            return false;
          }

          const rowData = jobListContext.data[parseInt(mouseOverRowIndex)];
          if (rowData.void > 0) {
            await showGlobalOkDialog(<p>This Invoice has been voided.</p>);
            return false;
          } else if (rowData.paidAmount !== 0) {
            await showGlobalOkDialog(<p>This Invoice has been already paid.</p>);
            return false;
          } else if (rowData.draft) {
            await showGlobalOkDialog(<p>This Invoice is Draft.</p>);
            return false;
          } else {
            return true;
          }
        }} />
    </div>
  );
}


function useSelectedOperations() {
  const fmsGlobal = getFmsGlobal();
  const jobListContext = useContext(JobListViewContext);
  const appContext = useContext(ApplicationContext);
  const history = useHistory();
  // const sourceUrl = `${history.location.pathname}${history.location.search}`;
  const operation = 'accounting';

  const selectedElement = jobListContext.selectedElement as InvoiceListItem;

  const [showGlobalOkDialog] = useGlobalOkDialog();
  const [showGlobalYesNoDialog] = useGlobalYesNoDialog();

  async function create() {
    if (jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(`/${operation}/acGeneralInvoice/add`)) {
      await showGlobalOkDialog(<p>New operation is already in progress.</p>);
      return;
    }

    openNewPage(history, `/${operation}/acGeneralInvoice/add`, NavigationType.newPage);
  }

  async function deleteItem() {
    if (!selectedElement) {
      return;
    }

    if (
      jobListContext.hasOpenedScreenStartingWithUrl(`/${operation}/acGeneralInvoice/edit/${selectedElement.id}`) || 
      jobListContext.hasOpenedScreenStartingWithUrl(`/${operation}/acGeneralInvoice/view/${selectedElement.id}`)
    ) {
      await showGlobalOkDialog('Need to close Invoice first', false, null, "warning");
      return;
    }

    const doDelete = await showGlobalYesNoDialog(
      <div>
        <h3>Confirm to Delete?</h3>
      </div>
    ,false, 0, true, 'warning');

    if (doDelete) {
      const apiResult = await appContext.api.deleteJobDetail(JobNames.Invoice, { id:selectedElement.id, opAcctBlockAfterClosed: fmsGlobal?.OPAcctBlockAfterClosed??false });
      if (apiResult && apiResult.success) {
        jobListContext.reloadData();
      } else {
        const message = apiResult?.message ?? 'Cannot delete!';
        await showGlobalOkDialog(message,false,null,'warning');
      }
    }
  }

  async function edit() {
    if (!selectedElement) {
      return;
    }

    const id = selectedElement?.id;
    const editUrl = `/${operation}/acGeneralInvoice/edit/${id}`;
    const viewUrl = `/${operation}/acGeneralInvoice/view/${id}`;
    
    // if (jobListContext.hasOpenedScreenStartingWithUrlWithoutMe(`/${operation}/acGeneralInvoice/edit`, editUrl)) {
    //   await showGlobalOkDialog(<p>Edit operation is already in progress.</p>);
    //   return;
    // }

    jobListContext.moveToOpenedScreenInAnyOperationStartingWithUrl(editUrl, [editUrl, viewUrl]);
  }

  async function view() {
    if (!selectedElement) {
      return;
    }

    const id = selectedElement?.id;
    const editUrl = `/${operation}/acGeneralInvoice/edit/${id}`;
    const viewUrl = `/${operation}/acGeneralInvoice/view/${id}`;

    const listSec = findSecurityTask(appContext, FmsSecTask.AcctGInvoList);
    const urls = [viewUrl];
    if (listSec?.grantEdit) urls.push(editUrl)

    jobListContext.moveToOpenedScreenInAnyOperationStartingWithUrl(viewUrl, urls);
  }

  async function copy() {
    if (!selectedElement) {
      return;
    }

    if (jobListContext.hasOpenedScreenStartingWithUrl(`/${operation}/acGeneralInvoice/add`)) {
      await showGlobalOkDialog(<p>New operation is already in progress.</p>);
      return;
    }

    const id = selectedElement.id;
    openNewPage(history, `/${operation}/acGeneralInvoice/add?copyId=${id}`, NavigationType.newPage);
  }

  async function viewPaymentHistory() {
    if (!selectedElement) {
      return;
    }

    const jobId = selectedElement.id;
    const jobName = JobNames.GInvo;
    const jobType = selectedElement.jobType

    const viewUrl = `/accounting/acPaymentHistoryView/${jobName}/${jobId}/${getJobNameFromInvBillCrDbJobType(jobType)}`;
    openNewPage(history, viewUrl, NavigationType.newPage);
  }

  return {create, deleteItem, edit, view, copy, operation, viewPaymentHistory };
}

function RightClickMenu({dismiss}:{dismiss: VoidFunction}) {
  const { create, deleteItem, edit, view, copy } = useSelectedOperations();
  const jobListContext = useContext(JobListViewContext);
  // const isDraft = jobListContext.selectedElement.draft;

  const appContext = useContext(ApplicationContext);
  const listSec = findSecurityTask(appContext, FmsSecTask.AcctGInvoList);

  const items = [
    { label: 'New', shortcut: 'F2', separator: false, hidden: !listSec?.grantAdd },
    { label: 'View', shortcut: 'F9', separator: !listSec?.grantEdit && !listSec?.grantDel },
    { label: 'Edit', shortcut: 'F3', separator: !listSec?.grantDel, hidden: !listSec?.grantEdit },
    { label: 'Delete', shortcut: '', separator: true, hidden: !listSec?.grantDel },
    { label: 'Search', shortcut: 'F5', separator: false },
    { label: constants.Doc_Server, shortcut: 'F8', separator: true, newCol: true },
    { label: 'Copy', shortcut: 'Ctrl+F2', separator: true, hidden: !listSec?.grantAdd },
  ];

  const menuItems: ActionButtonItem[] = items.map((i, index) =>({
    label: <ToolboxMenuItem name="gInvoice-list-sub-menu" width="190px" label={i.label} shortcut={i.shortcut} />,
    separator: i.separator,
    selected: false,
    newCol: i.newCol,
    index,
    hidden: i?.hidden ?? false,
  }));

  function onMenuItemSelected(item:IfmsMenuItem) {
    switch (item.index) {
      case 0:
        create();
        break;
      case 1:
        view();
        break;
      case 2:
        edit();
        break;
      case 3:
        deleteItem();
        break;
      case 4:
        jobListContext.triggerTableSearch('F5');
        break;
      case 5:
        jobListContext.setInfoAreaContent(jobListContext.infoAreaContent === 'memo' ? 'none' : 'memo');;
        break;
      case 6:
        copy();
        break;
      default:
        break;
    }
    dismiss();
  }

  return (
    <Menu
      variant="plain"
      specialMenu='rightClickContext'
      items={splitMenuItemsIntoSections(menuItems)}
      mode="vertical"
      onMenuItemSelected={onMenuItemSelected}
      subMenuStyle={{
        minWidth: 150,
        whiteSpace: 'nowrap',
      }}
      menuStyle={(i: number) => ({
        maxHeight: '300px',
        overflowY: 'hidden',
        padding: 0,
        borderTop: `3px solid ${borderColors[i % borderColors.length]}`,
        paddingTop: 10,
      })}
      dismiss={dismiss}
    />
  );
}

// function TrancationImpactButtonCommands() {
//   const jobListContext = useContext(JobListViewContext);
//   const selectedElement = jobListContext.selectedElement as InvoiceListItem;
//   const {switchJournal} = useJournal();
//   const suntekSettings = useSuntekSettings();
  
//   if (!suntekSettings.accounting?.allowTransactionImpact) {
//     return null;
//   }

//   return (
//     <PrimaryButton
//       size="regular"
//       onClick={()=> switchJournal(JobNames.GInvo, selectedElement.id)}>
//       {constants.List_Journal}
//     </PrimaryButton>
//   );
// }

function ListCommands() {
  const history = useHistory();
  const jobListContext = useContext(JobListViewContext);
  const [selectedPopupMenuItem, setSelectedPopupMenuItem] = useState<ActionButtonItem|null>(null);

  const selectedElement = jobListContext.selectedElement as InvoiceListItem;

  const {deleteItem, edit, view, copy, operation, /* viewPaymentHistory */} = useSelectedOperations();

  const appContext = useContext(ApplicationContext);
  const [showGlobalYesNoDialog] = useGlobalYesNoDialog();
  const [showGlobalOkDialog] = useGlobalOkDialog();
  const { viewReport } = useReportViewer();
  
  function hasOpenedNew() {
    return jobListContext.hasOpenedScreenStartingWithUrl(`/${operation}/acGeneralInvoice/add`);
  }

  const listSec = findSecurityTask(appContext, FmsSecTask.AcctGInvoList);
  //const hasSecCp = getSecBySecTask(appContext, FmsSecTask.AcctCustPayment, SecType.Add);
  //const hasSecBp = getSecBySecTask(appContext, FmsSecTask.AcctBillPayment, SecType.Add);

  const hasSelectedRow = !!selectedElement;
  const canBeDeleted = hasSelectedRow && listSec?.grantDel;
  const canBeCopied = hasSelectedRow && !hasOpenedNew() && listSec?.grantAdd;
  const canBeAdd =  listSec?.grantAdd;
  const canBeEdit = hasSelectedRow && listSec?.grantEdit;
  //const disablePrint = hasSelectedRow && selectedElement.draft;

  const onPopupClose = () => {
    setSelectedPopupMenuItem(null);
  }

  async function print(){
    if (!selectedElement) {
      return;
    }

    let puInvoice: boolean = false;
    if (appContext.suntekSettings?.company?.companyId === "AECL002209") {
      const doConfirm = await showGlobalYesNoDialog(
        <div>
          <h3>Confirm to Print?</h3>
          <p>Do you want to print P/U Invoice?</p>
        </div>
      ,false, 0, true);
      if (doConfirm) {
        puInvoice = true;
      }
    }

    if(!puInvoice && appContext.suntekSettings?.company?.country === "MEXICO" && appContext.suntekSettings?.company?.companyId === "PEOP002103"){
        // Batch Invoice
        setSelectedPopupMenuItem({label: 'Invoice Batch Print', popupComponent: <BatchPrint selectedElement={selectedElement} documentType={DocumentType.InvoiceS} jobName={JobNames.RptInvoiceS} /> });
    }else{
      const args = await getSelectedSubMenuArgs(puInvoice ? FmsSubMenu.PuInvoice : FmsSubMenu.Invoice, JobNames.Invoice, selectedElement, appContext, null, null);
      if(args){
        viewReport(args, "", true);
      }
    }
  }

  // async function onCustomerBillAction(item: ActionButtonItem) {
  //   //const link = item.index === 0 ? `/accounting/acCustomerPayment/add/${selectedElement.invoiceTo}` : `/accounting/acBillPayment/add/${selectedElement.invoiceTo}`;
  //   let link = '';

  //   switch (item.index) {
  //     case 0:
  //       link = `/accounting/acCustomerPayment/add`;
  //       break;
  //     case 1:
  //       link = `/accounting/acBillPayment/add`;
  //       break;
  //     case 2: jobListContext.setFilterForScreenExternally('/common/joblistview/acCustomerPayment/accounting', 
  //       'invoiceNo', 'Billings', selectedElement.invoiceNo, 'updated', false, true, null );
  //       openNewPage(history, '/common/joblistview/acCustomerPayment/accounting', NavigationType.newPage);
  //       return;
  //     case 3:

  //     jobListContext.setFilterForScreenExternally('/common/joblistview/acBillPayment/accounting', 
  //       'invoiceNo', 'Billings', selectedElement.invoiceNo, 'updated', false, true, null);
  //       openNewPage(history, '/common/joblistview/acBillPayment/accounting', NavigationType.newPage);
  //       return;
  //   }
    
  //   if (jobListContext.hasOpenedScreenStartingWithUrl(link)) {
  //     await showGlobalOkDialog(<p>Operation is already in progress.</p>);
  //     return;
  //   }

  //   openNewPage(history, `${link}/${selectedElement.invoiceTo}`, NavigationType.newPage);
  // }

  // async function onHistoryAction(item: ActionButtonItem) {
  //   if (item.index === 0) {
  //     viewPaymentHistory();
  //   }

  //   if (item.index === 1) {
  //     setSelectedPopupMenuItem({ label: 'View History', popupWidth: 1200, popupComponent: <HistoryViewDetails jobId={selectedElement.id} jobType={selectedElement.jobType} jobName={JobNames.GInvo} /> })
  //   }
  // }

  async function invoiceBalance() {
    if (selectedElement.invoiceTo <= 0 && (selectedElement.invoiceToName === null || selectedElement.invoiceToName === '')) {
      await showGlobalOkDialog(<p>You didn't enter Agent.</p>,false,null,'warning');
      const focusElement = document.getElementById('generalInvoice-invoiceTo');
      if (focusElement) {
        focusElement.focus();
      }
      return;
    }
    setSelectedPopupMenuItem({
      label: 'Balance',
      popupWidth: 780,
      popupComponent:
        <CustomerBalanceDetails
          jobId={selectedElement.id}
          jobName={JobNames.GInvo}
          onPopupClose={onPopupClose}
          //toDate={invoice.postDate || ''}
          toDate={nowDate()}
          comId={selectedElement.invoiceTo}
          comType={'C'}
          branch={''}
          subCode={''}
          customerName={selectedElement.invoiceToName}
        />
    })
  }

  return (
    <div className={!appContext.useDarkMode ? "ifms-common-vertical-separator" : "ifms-common-vertical-separator-darkmode"}>
      <div className="ifms-common-no-vertical-separator">
        <UniqueLinkButton name='gInvoice-list-add-button' display="primary" size="regular" link={`/${operation}/acGeneralInvoice/add`} disabled={!canBeAdd} label="New"/>&nbsp;
        <PrimaryButton name='gInvoice-list-view-button' size="regular" disabled={!hasSelectedRow} onClick={view}>View</PrimaryButton>&nbsp;
        <PrimaryButton name='gInvoice-list-edit-button' size="regular" disabled={!canBeEdit} onClick={edit}>Edit</PrimaryButton>&nbsp;
        <PrimaryButton name='gInvoice-list-delete-button' size="regular" disabled={!canBeDeleted} onClick={deleteItem}>Delete</PrimaryButton>&nbsp;
        <PrimaryButton name='gInvoice-list-copy-button' size="regular" disabled={!canBeCopied/* || disablePrint*/} onClick={copy}>Copy</PrimaryButton>
      </div>
      <div className={!appContext.useDarkMode ? "ifms-common-vertical-separator" : "ifms-common-vertical-separator-darkmode"}>
        {/* <PrimaryButton name='gInvoice-list-print-button' size="regular" disabled={disablePrint} onClick={print}> Print</PrimaryButton>&nbsp; */}
        {/* <PrimaryButton name='gInvoice-list-batchPrint-button' size="regular" disabled={disablePrint} onClick={() => setSelectedPopupMenuItem({label: 'Batch Print G. Invoice', popupComponent: <BatchPrint documentType={DocumentType.InvoiceS} selectedElement={selectedElement} jobName={JobNames.GInvo} /> })}>Batch Print</PrimaryButton>&nbsp; */}
        
        {/* {(hasSecCp || hasSecBp) &&
          <>
        <ActionButton
          name='gInvoice-list-pay-button' 
          type="primary"
          items={[
            {label: 'New Customer Pay', separator: false, index: 0, hidden: !hasSecCp},
            {label: 'New Bill Pay', separator: true, index: 1, hidden: !hasSecBp },
            { label: 'Customer Pay List', separator: false, index: 2, hidden: !hasSecCp, name: "gInvoice-list-sub-customerpayList-button"},
            { label: 'Bill Pay List', separator: false, index: 3, hidden: !hasSecBp , name: "gInvoice-list-sub-billpayList-button"},
          ]}
          onItemSelected={onCustomerBillAction}
        >
          Pay
        </ActionButton>&nbsp;
        </>
        } */}
        {/* <PrimaryButton size="regular" disabled={!hasSelectedRow} onClick={() => setSelectedPopupMenuItem({ label: 'Payment History', popupWidth: 1050, popupComponent: <PaymentHistory jobId={selectedElement.id} jobName={JobNames.GInvo} /> })}>Payment History</PrimaryButton>&nbsp; */}
        
        {/* General Invoice의 경우 상단 메뉴가 많아서 History 아래 Payment History, View History를 표시 */}
        {/* <PrimaryButton size="regular" onClick={viewPaymentHistory}>Payment History</PrimaryButton>&nbsp; */}
        {/* <PrimaryButton size="regular" disabled={!hasSelectedRow} onClick={() => setSelectedPopupMenuItem({ label: 'View History', popupWidth: 1200, popupComponent: <HistoryViewDetails jobId={selectedElement.id} jobType={selectedElement.jobType} jobName={JobNames.GInvo} /> })}>View History</PrimaryButton>&nbsp; */}
        {/* <ActionButton
          name='gInvoice-history-button' 
          type="primary"
          items={[
            {label: 'Payment History', separator: false, index: 0, name:'gInvoice-list-payment-button', hidden: !hasSelectedRow},
            {label: 'View History', separator: false, index: 1, name:'gInvoice-list-viewhistory-button'},
          ]}
          onItemSelected={onHistoryAction}
        >
          History
        </ActionButton>&nbsp; */}
        <PrimaryButton
          name='gInvoice-print-button'
          size='regular'
          disabled={!hasSelectedRow}
          onClick={print}
          >
          Print
        </PrimaryButton>&nbsp;
        <PrimaryButton
          name='gInvoice-balance-button' 
          size="regular"
          disabled={!hasSelectedRow}
          onClick={invoiceBalance}>
          Balance
        </PrimaryButton>
      </div>
      {/* <div className={!appContext.useDarkMode ? "ifms-common-vertical-separator" : "ifms-common-vertical-separator-darkmode"}>
      <PrimaryButton
          name='gInvoice-autobilling-button' 
          size="regular"
          disabled={!hasSelectedRow}
          //onClick={}
          >
          Auto Billing
        </PrimaryButton>
      </div> */}

      {!!selectedPopupMenuItem && !!selectedPopupMenuItem.popupComponent ? (
        <IfmsModal isBlueHeader cancelOnEsc onCancel={onPopupClose} draggable isOpen={!!selectedPopupMenuItem} title={selectedPopupMenuItem?.popupLabel || selectedPopupMenuItem?.label} width={`${selectedPopupMenuItem?.popupWidth || 760}px`}>
          {cloneElement(selectedPopupMenuItem.popupComponent!, {onPopupClose})}
        </IfmsModal>
      ) : null}
    </div>
  );
}

function ListToolbar() {
  return (
    <>
      <ListViewShortcutMenu />
    </>
  );
}

function ListViewExtras({
  hideLogHistory
}: any,
) {
  useFunctionKeys({onFunction: onFunctionKey});
  
  const jobListContext = useContext(JobListViewContext);
  const appContext = useContext(ApplicationContext);
  const listSec = findSecurityTask(appContext, FmsSecTask.AcctGInvoList);
  const history = useHistory();

  const {copy, create, edit, view} = useSelectedOperations();

  const [unprocessedFkey, setUnprocessedFkey] = useState<string | null>(null);

  useEffect(() => {
      if (!unprocessedFkey) {
        return;
      }

      doProcessFkey();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [unprocessedFkey]
  );

  function doProcessFkey() {
    if (unprocessedFkey === 'F6') {

    } else if (unprocessedFkey === "CTRL+F2") {
      if(listSec?.grantAdd)
        copy();
    } else if (unprocessedFkey === "F2") {
      if(listSec?.grantAdd)
        create();
    } else if (unprocessedFkey === "F3") {
      if(listSec?.grantEdit)
        edit();
    } else if (unprocessedFkey === "F9") {
      view();
    } else if (unprocessedFkey === "F11") {
      jobListContext.reloadData();
    } else if (unprocessedFkey === "F8") {
      jobListContext.setInfoAreaContent(jobListContext.infoAreaContent === 'memo' ? 'none' : 'memo');;
    }

    setUnprocessedFkey(null);
  }

  function onFunctionKey(fkey: string) {
    if (['F6', 'F2', 'CTRL+F2', 'F3', 'F9', 'F11', 'F8'].indexOf(fkey) >= 0) {
      setUnprocessedFkey(fkey);
      return true;
    }

    return false;
  }

  function onLinkToAccounting(entity: any) {
    if (!entity || !entity.category || !entity.number) {
      return;
    }

    if (entity.category === 'Bill') {
      jobListContext.setFilterForScreenExternally('/common/joblistview/bill/oceanExport', 'billNo', 'Bill #', entity.number, 'updated', false, true);
      openNewPage(history, `/common/joblistview/bill/oceanExport`, NavigationType.newPage);
    }
    if (entity.category === 'Invoice') {
      jobListContext.setFilterForScreenExternally('/common/joblistview/invoice/oceanExport', 'invoiceNo', 'Invoice #', entity.number, 'updated', false, true);
      openNewPage(history, `/common/joblistview/invoice/oceanExport`, NavigationType.newPage);
    }
    if (entity.category === 'CrDb') {
      jobListContext.setFilterForScreenExternally('/common/joblistview/crdb/oceanExport', 'crdbNo', 'CrDb #', entity.number, 'updated', false, true);
      openNewPage(history, `/common/joblistview/crdb/oceanExport`, NavigationType.newPage);
    }
  }

  async function loadInfoAreaInvoiceBillCrDb(id: string) {
    const apiResult = await appContext.api.getOceanImportMblInfoAreaBics(id);
    if (!apiResult) {
      return null;
    }

    const tableOptions: ApplicableTableSettings = {
      tableName: 'infoAreaBicTable',
      ...infoAreaBicTable,
      data: apiResult,
      
      rowRenderers: [
        {accessor: 'date', Cell: TextRenderer},
        {accessor: 'category', Cell: TextRenderer},
        // @ts-ignore:next-line
        {accessor: 'number', Cell: AccountingEntityRenderer.bind(this, onLinkToAccounting)},
        {accessor: 'companyName', Cell: TextAlignLeftRenderer},
        {accessor: 'cur', Cell: TextRenderer},
        // @ts-ignore:next-line
        {accessor: 'amount', Cell: ({cell}) => CurrencyRenderer(cell.row.values.amount, cell.row.values.cur)},
        // @ts-ignore:next-line
        {accessor: 'paidAmount', Cell: ({cell}) => CurrencyRenderer(cell.row.values.paidAmount, cell.row.values.cur)},
        // @ts-ignore:next-line
        {accessor: 'balance', Header: () => <div style={{marginRight: '8px'}}>Balance</div>, Cell: ({cell}) => CurrencyRenderer(cell.row.values.balance, cell.row.values.cur, true)},
      ],
    };

    return (
      <div style={{width: `${infoAreaBicTable.width}`, marginLeft: 'auto', marginRight: 'auto'}}>
        <SmartTable {...tableOptions} />
      </div>
    );
  }

  return (
    <InfoAreaDrawer
      showContent={jobListContext.infoAreaContent}
      //entityName={constants.infoAreaEntity.oceanExportMbl}
      jobName={JobNames.GInvo}
      //entityId={(jobListContext.selectedElement as OeMblListItem | null)?.id}
      jobId={(jobListContext.selectedElement as InvoiceListItem | null)?.id ?? 0}
      customTabs={[
        {
          headline: 'Billings Info',
          contentLoader: loadInfoAreaInvoiceBillCrDb,
        },
      ]}
      onClose={() => jobListContext.setInfoAreaContent('none')}
      hideLogHistory={hideLogHistory}
    />
  );
}

/**
 * Concrete implementation for Quotation List screen
 *
 * @class GeneralInvoiceListView
 * @extends {AbstractListView}
 */
class GeneralInvoiceListView extends AbstractListView {
  async fetchAndFormatData(api: any, search: Search): Promise<DataFetchResult> {
    const searchModel = InvoiceListItem.calculateSearchParameters(search, InvoiceListItem.MapSearchFields, ['void']);
    const apiResult = await api.getListItems(
      JobNames.GInvo,
      'InvoiceListItem',
      searchModel,
      1,
      search.pageSize,
    );

    if (!apiResult || !apiResult.entities || apiResult.entities.length <= 0) {
      return {data: [], totalCount: 0};
    }

    return {data: InvoiceListItem.formatData(apiResult.entities), totalCount: apiResult.totalCount};
  }

  getCustomFilterRenderers(): ListCustomFilterRenderer[] {
    return [
      {
        accessor: 'statusNotUseFileLocked',
        renderer: StatusNotUseFileLockedRenderer,
        searchValueExtractor: (v:any|null|undefined) => v,
      },
      // {
      //   accessor: 'void',
      //   renderer: VoidFilterRenderer,
      //   searchValueExtractor: (v:any|null|undefined) => v === 'V' ? 1 : 0,
      // },
      //{
      //  accessor: 'draft',
      //  renderer: DraftFilterRenderer,
      //  searchValueExtractor: (v:any|null|undefined) => v === 'D' ? true : false,
      //},
      {
        accessor: 'confirmed',
        renderer: undefined,
        searchValueExtractor: (v: any | null | undefined) => v.value !== undefined ? v.value : v,
      },
    ];
  }

  getInfoAreaEntityId() {
    return constants.infoAreaEntity.oceanImportMbl;
  }

  getRowRenderers(opType: string, systemSettings: SystemSettings, suntekSettings: SuntekSettings): ListRowRenderer[] {
    const useBranch = systemSettings?.enableBranch ?? false;
    const useVat = systemSettings.useVat ?? false;
    return InvoiceListItem.getExportCollection(JobNames.GInvo, useBranch, useVat).map(x => {
      const colRenderer: ListRowRenderer = { accessor: x.dataIndex, Cell: TextAlignLeftRenderer };
      if (x.align === XCol.XAlignType.Center) colRenderer.Cell = TextRenderer;
      else if (x.align === XCol.XAlignType.Right) colRenderer.Cell = TextAlignRightRenderer;
      if (x.dataIndex === "status") {
        colRenderer.Cell = IndicatorRenderer;
      } else if (x.dataIndex === "draft") {
        // colRenderer.Cell = DraftRenderer;
        colRenderer.Cell = NullableCheckboxIconRenderer;
      // } else if (x.dataIndex === "void") {
      //   colRenderer.Cell = VoidRenderer;
      }else if (x.dataIndex === "confirmed") {
        colRenderer.Cell = ConfirmedRenderer;
      } 
      else if (x.dataIndex === "amount" || x.dataIndex === "paidAmount" || x.dataIndex === "balance" || x.dataIndex === "cAmount" || x.dataIndex === "vatAmount") {
        colRenderer.Cell = props => <CurrencyAmountRenderer currencyAccessor={(x: any) => x.currency} {...props} />;
      } else if (x.dataIndex === "referenceNo" || x.dataIndex === "hblNo") {
        colRenderer.Cell = TextAlignLeftRenderer;
      } else if (x.dataIndex === 'u2Date') {
        colRenderer.Cell = DateTimeIncludeSecRenderer;
      } else if (x.dataIndex === 'overDue') {
        colRenderer.Cell = props => <FloatRenderer {...props} decimals={0} />;
      } 
      else if (x.type === XCol.XCellType.Bool || x.type === XCol.XCellType.StrBool) colRenderer.Cell = NullableCheckboxIconRenderer;
      else if (x.type === XCol.XCellType.Date) colRenderer.Cell = DateRenderer; 
      else if (x.type === XCol.XCellType.DateTime) colRenderer.Cell = DateTimeRenderer;
      else if (x.type === XCol.XCellType.Double) colRenderer.Cell = FloatRenderer;
      return colRenderer;
    });
  }

  getExportRenderers(): ExportRowRenderer[] {
    const colRenderer = [];
    colRenderer.push({ accessor: 'status', changedValue: (value: any) => { return value['status'] === 'PC' ? 'Period Close' : '' } });
    colRenderer.push({ accessor: 'amount', changedValue: (value: any) => { return CurrencyAmountValue(value['currency'], value['amount']) } });
    colRenderer.push({ accessor: 'paidAmount', changedValue: (value: any) => { return CurrencyAmountValue(value['currency'], value['paidAmount']) } });
    colRenderer.push({ accessor: 'balance', changedValue: (value: any) => { return CurrencyAmountValue(value['currency'], value['balance']) } });
    colRenderer.push({ accessor: 'cAmount', changedValue: (value: any) => { return CurrencyAmountValue(value['currency'], value['cAmount']) } });
    colRenderer.push({ accessor: 'dutyAmount', changedValue: (value: any) => { return CurrencyAmountValue(value['currency'], value['dutyAmount']) } });
    colRenderer.push({ accessor: 'vatAmount', changedValue: (value: any) => { return CurrencyAmountValue(value['currency'], value['vatAmount']) } });
    colRenderer.push({ accessor: 'draft', changedValue: (value: any) => { return nullableCheckBoxValue(value['draft'])}});
    colRenderer.push({ accessor: 'confirmed', changedValue: (value: any) => { return nullableCheckBoxValue(value['confirmed'])}});
    colRenderer.push({ accessor: 'confirmed', changedValue: (value: any) => { return DateTimeSecond(value['confirmed'])} });
    return colRenderer;
  }

  getDefaultOrderBy(): ListOrderBy {
    return {
      orderBy: 'u2Date',
      orderByAscending: false,
    };
  }

  getTableSettings(opType:string, systemSettings:SystemSettings, suntekSettings:SuntekSettings): TableSettings {
    const useBranch = systemSettings?.enableBranch ?? false;
    const useVat =  systemSettings.useVat ?? false;
    const tsettings =  generalInvoiceList;
    const cols = InvoiceListItem.getExportCollection(JobNames.GInvo, useBranch, useVat);
    tsettings.columns = cols.map<TableColumn>(x => {
      return { ...x, accessor: x.dataIndex, Header: x.text, filterType: undefined, filterTypeV2: x.type};
    });
    return tsettings;
  }

  renderCommands() {
    return (
      <ListCommands/>
    );
  }

  renderBeforeConfigureButton() {
    return (
      <ListToolbar/>
    );
  }

  renderExtras(hideLogHistory: boolean) {
    return <ListViewExtras hideLogHistory={hideLogHistory} />
  }

  getViewUrlFor(row: InvoiceListItem) {
    return row && row.id ? `/accounting/acGeneralInvoice/view/${row.id}` : '';
  }

  getListViewTitle() {
    return 'General Invoice List';
  };
  
  renderAdditionalCommands() {
    return <JobListSuntekCommand jobName={JobNames.GInvo} keyProp='id' showAdjustBalance={false} />;
  }

  hasRightClickContext(): boolean {
    return true;
  }

  renderRightClickContext(context: RightClickContext, dismiss: VoidFunction): React.ReactNode {
    return <RightClickMenu dismiss={dismiss} />;
  }

  useLogHistory(): boolean {
    return true;
  }

  // transactionImpactBtn(): React.ReactNode {
  //   return <TrancationImpactButtonCommands/>
  // }
}

export default GeneralInvoiceListView;
